// src/pages/RouteEntriesDetail.jsx

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../utils/api";
import styled from "styled-components";
import { useAuth } from "../context/AuthContext";

const Container = styled.div` padding: 2rem; background: #fff7ed; min-height: 100vh; `;
const Header = styled.div` background: white; padding: 1.5rem; border-radius: 16px; margin-bottom: 2rem; box-shadow: 0 8px 25px rgba(249,115,22,0.15); `;
const Title = styled.h1` margin: 0; color: #1e293b; font-size: 1.8rem; `;
const Info = styled.div` margin-top: 12px; color: #475569; `;
const Badge = styled.span` background: #fef3c7; color: #92400e; padding: 6px 12px; border-radius: 20px; font-weight: 600; margin-right: 10px; `;

const SurveyorCard = styled.div`
  background: white;
  padding: 1.4rem;
  border-radius: 14px;
  margin-bottom: 1rem;
  box-shadow: 0 6px 20px rgba(0,0,0,0.08);
  cursor: pointer;
  transition: 0.2s;
  &:hover { transform: translateY(-4px); box-shadow: 0 12px 30px rgba(249,115,22,0.2); }
`;

const EntryTag = styled.span`
  background: #f97316;
  color: white;
  padding: 6px 12px;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: bold;
  margin: 4px;
  display: inline-block;
`;
const BackButton = styled.button`margin-top:14px;
padding:10px 16px;
border-radius:10px;
border:none;
background:#f47d39ff;
color:#fff;
font-weight:700;
cursor:pointer;
font-size:.95rem;
margin-bottom: 20px;
box-shadow:0 8px 20px rgba(249,115,22,0.12);`;


export default function RouteEntriesDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { token } = useAuth();
  const [route, setRoute] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRoute = async () => {
      try {
        const res = await api.get(`/api/dataanalysis/routes/${id}/entries`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setRoute(res.data.route);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchRoute();
  }, [id, token]);

  if (loading) return <Container>Loading route details...</Container>;
  if (!route) return <Container>Route not found</Container>;

  // Group entries by surveyor
  const entriesBySurveyor = {};
  route.entries.forEach(entry => {
    const userId = entry.user?._id || "unknown";
    if (!entriesBySurveyor[userId]) {
      entriesBySurveyor[userId] = {
        surveyor: entry.user,
        entries: []
      };
    }
    entriesBySurveyor[userId].entries.push(entry);
  });

  return (
    <Container>
      <BackButton onClick={() => navigate(`/entries`)}>
              Back
            </BackButton>
            <br></br>
      <Header>
        
        <Title>{route.name}</Title>
        <div style={{marginTop: "8px", fontSize: "1.1rem", color: "#f97316"}}>{route.routeCode}</div>
        <Info>
          <Badge>{route.assignedUsers.length} Surveyors Assigned</Badge>
          <Badge style={{background: "#dcfce7", color: "#166534"}}>{route.entries.length} Total Entries</Badge>
          <span> | Created by: {route.createdBy?.name}</span>
        </Info>
      </Header>

      <h2 style={{color: "#1e293b", marginBottom: "1rem"}}>Entries by Surveyor</h2>

      {Object.values(entriesBySurveyor).map(({ surveyor, entries }) => (
        <SurveyorCard key={surveyor._id}>
          <h3 style={{margin: "0 0 12px", color: "#1e293b"}}>
            {surveyor.name} ({surveyor.email})
          </h3>
          <div>
            {entries.map((entry, idx) => (
              <EntryTag
                key={entry._id}
                onClick={() => navigate(`/entries/entry/${entry._id}`)}
              >
                D{idx + 1}
              </EntryTag>
            ))}
          </div>
        </SurveyorCard>
      ))}
    </Container>
  );
}